import {widgetFromDomaintypeGenerator} from "../../../misc/widget-functions"
import React from "react"
import {Box, Typography} from "@mui/material"
import Listenobjekt from "./Listenobjekt"
import QuestionToWidget from "./QuestionToWidget"
import Content from "../../../components/Content"

const UnterobjektToWidget = ({unterobjekt, sections, widget}) => {
    return unterobjekt.connections?.map((connection) => {
        const merkmal = connection.origin
        if (!merkmal) {
            
            return null
        }
        if (
            merkmal.children?.length &&
            merkmal.multiple
        ) {
            return (
                <Box
                    key={merkmal.id}
                    gridColumn="span 2">
                    <Listenobjekt
                        listObject={merkmal}
                        unterobjekt={unterobjekt}
                    />
                </Box>
            )
        } else if (merkmal.children?.length) {
            return merkmal.children.map((child) => (
                <React.Fragment key={child.id}>
                    <Typography variant="body1">
                        {child.question ||
                            child.kurzname}
                    </Typography>
                    <Content
                        child={widgetFromDomaintypeGenerator(
                            child,
                            merkmal.pointer,
                            widget.questionaire,
                        )}
                    />
                </React.Fragment>
            ))
        } else {
            return (
                <QuestionToWidget key={merkmal.id} merkmal={merkmal} widget={widget}
                                  sections={sections} />
            )
        }
    })
}

export default UnterobjektToWidget
